module.exports = __webpack_public_path__ + "assets/1b9d190122fcb3f4450df561175e5035.png";